
import useTranslation from '../../hooks/useTranslation'
import pc from '../../../assets/image/intro/pc.png'
import ComponentRenderer from './ComponentRenderer'

function DesignContent() {
  const t = useTranslation()
  const intro = t.landing.intro.design
  return (
    <ComponentRenderer
      headline={intro.headline}
      subline={intro.body}
      ctaLabel={intro.ctaLabel}
      ctaHref={intro.ctaHref}
      image={pc}
      bulletsTitle={intro.servicesLabel}
      bullets={intro.servicesList}
    />
  )
}

export default DesignContent
